/** Message affiché si pas de réseau ou échec chrono (aligné API 503) */
export const CHRONO_OFFLINE_MSG =
  'Récupération de numéro chrono impossible, veuillez vous connecter au réseau';

/**
 * Libellé liste / détail : numéro officiel ou brouillon + 8 premiers caractères de l'id (sans tirets).
 */
export function formatRapportDisplayLabel({ meta, missionId }) {
  const rawNum = meta?.numero;
  if (rawNum != null && String(rawNum).trim() !== '') {
    return String(rawNum).trim();
  }
  const rawId = meta?.id || missionId || '';
  const short = String(rawId).replace(/-/g, '').slice(0, 8);
  return `Brouillon · ${short}`;
}

export async function saveRapportMetaFromApiRapport(inspectionStorage, missionId, rapport) {
  if (!rapport?.id || !inspectionStorage || !missionId) return;
  await inspectionStorage.set(`mission_${missionId}_rapport_meta`, {
    id: rapport.id,
    numero: rapport.numero ?? null,
    statut: rapport.statut ?? null,
  });
}
